import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AuthModule } from './auth/auth.module';
import { RouterModule } from '@angular/router';
import { ErrorComponent } from './error/error.component';
import { WarnComponent } from './warn/warn.component';
import { InfoComponent } from './info/info.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { ConfirmationService } from './confirmation/confirmation.service';
import { ErrorService } from './error/error.service';
// import { EntityHelpComponent } from './entity-help/entity-help.component';
import { AboutComponent } from './about/about.component';
import { ProgressComponent } from './progress/progress.component';
import { ProcessProgressService } from './progress/processProgress.service';
import { SpinnerComponent } from './spinner/spinner.component';
import { CalendarComponent } from './calendar/calendar/calendar.component';
import { NgbModule, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from './spinner/spinner.service';
import { CountdownComponent } from './countdown/countdown.component';
import { AppInputPasswordDirective } from '@app/shared/directive/app-input-password.directive';
import { ChangePasswordComponent } from './password/change-password.component';
import { FormErrorComponent } from './form-error/form-error.component';
import { ForgotPasswordComponent } from './password/forgot-password/forgot-password.component';
import { ToastComponent } from './info/toast/toast.component';


@NgModule({
  declarations: [
    LoginComponent,
    ChangePasswordComponent,
    SpinnerComponent,
    ErrorComponent,
    WarnComponent,
    InfoComponent,
    ToastComponent,
    ConfirmationComponent,
    // EntityHelpComponent,
    AboutComponent,
    ProgressComponent,
    CalendarComponent,
    CountdownComponent,
    AppInputPasswordDirective,
    FormErrorComponent,
    ForgotPasswordComponent,
    ToastComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    AuthModule,
    RouterModule,
    NgbModule,
    NgbToastModule
  ],
  exports: [
    LoginComponent,
    ChangePasswordComponent,
    AuthModule,
    SpinnerComponent,
    ErrorComponent,
    WarnComponent,
    InfoComponent,
    ToastComponent,
    ConfirmationComponent,
    // EntityHelpComponent,
    ProgressComponent,
    CountdownComponent,
    AppInputPasswordDirective,
    FormErrorComponent
  ],
  providers: [ ConfirmationService, ErrorService, ProcessProgressService, SpinnerService ]
  // entryComponents: [ ConfirmationComponent, ErrorComponent, AboutComponent, CalendarComponent, SpinnerComponent ],
})
export class CoreModule { }
